import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';

import Bs4GenericField from './Bs4GenericField'

export default class Bs4Empty extends Bs4GenericField {

  hesValue () {return false;}
  
  ViewComponentField = (props) => {
    const formField  = this;
    const theme = useTheme();
    return (
      <FormControl fullWidth>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Typography sx={{color: theme.palette.error.main}}>{'Nie można wyświetlić elementu. Proszę sprawdzić konfigurację.'}</Typography>
      </FormControl>      
    )
  }
}